<ng-template #template let-row="row">
  <div class="project-lose no-select" *ngIf="row?.failureReason && row.stage === ProjectStage.STAGE_LOST">
    <status-reason
      [color]="'red'"
      [label]="'Projects.FailureReason.' + row?.failureReason | translate"
      [comment]="row.failureNote ? row.failureNote : ('ProjectsList.noFailureNote' | translate)"
      [showTooltipWithComment]="true"
    />
  </div>
</ng-template>
